import type { ClientWorkspaceConfig } from "@ext/workspace/WorkspaceConfig";

const hasEnterpriseWorkspace = (
	gesUrl: string | undefined,
	workspaces: Pick<ClientWorkspaceConfig, "enterprise">[],
): boolean => !!gesUrl && workspaces.some((workspace) => workspace.enterprise?.gesUrl === gesUrl);

export default hasEnterpriseWorkspace;
